import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { fileUrl } from "../../../api/api";
import { route } from "../../../router/route";
import LSRgH1HeadLine from "../../molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import LSRgDisplay02 from "../../molecules/text/linSeedKr/Rg/lsRgDisplay02";
import styled from "styled-components";

function TogetherSwiper({ dataList }) {
  const navigate = useNavigate();
  const swiperRef = useRef();

  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <>
      <div
        style={{
          position: "relative",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "100%" }}>
          <Swiper
            onSwiper={(it) => {
              swiperRef.current = it;
            }}
            onSlideChange={(swiper) => {
              setActiveIndex(swiper.snapIndex);
            }}
            slidesPerView={2}
            spaceBetween={30}
            grabCursor={true}
            slidesPerGroup={1}
            modules={[Pagination]}
          >
            {dataList?.length > 0
              ? dataList?.map((item) => {
                  return (
                    <SwiperSlide key={item.id}>
                      <div
                        style={{
                          borderRadius: 15,
                          overflow: "hidden",
                        }}
                      >
                        <SlideContainer
                          onClick={() => {
                            navigate(`${route.column_detail}/${item.id}`);
                          }}
                          backgroundImage={
                            item.thumbnailServerFileNameMain
                              ? `${fileUrl}/${item.thumbnailServerFileNameMain}`
                              : null
                          }
                        >
                          <LSRgH1HeadLine
                            style={{
                              marginBottom: 8,
                              color: "#fff",
                            }}
                          >
                            {item.columnCategory?.title ?? "금융 칼럼"}
                          </LSRgH1HeadLine>
                          <ColumnTitleText
                            style={{
                              color: "#fff",
                            }}
                          >
                            {item.title}
                          </ColumnTitleText>
                        </SlideContainer>
                      </div>
                    </SwiperSlide>
                  );
                })
              : null}
          </Swiper>
        </div>

        {activeIndex >= 1 ? (
          <img
            onClick={() => swiperRef.current?.slidePrev()}
            style={{
              position: "absolute",
              cursor: "pointer",
              left: 0,
              width: 48,
              height: 48,
              top: "44%",
              transform: "translate(-50%, -50%)",
              zIndex: 10,
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // 그림자 추가
              objectFit: "contain", // 원본 비율 유지
              borderRadius: 999,
            }}
            src="/assets/icons/left_swiper.png"
            alt="left_swiper"
          />
        ) : null}

        {activeIndex < Math.max(0, (dataList?.length ?? 0) - 2) && (
          <img
            onClick={() => swiperRef.current?.slideNext()}
            style={{
              position: "absolute",
              cursor: "pointer",
              right: -50,
              width: 48,
              height: 48,
              top: "44%",
              transform: "translate(-50%, -50%)",
              zIndex: 10,
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // 그림자 추가
              objectFit: "contain", // 원본 비율 유지
              borderRadius: 999,
            }}
            src="/assets/icons/right_swiper.png"
            alt="right_swiper"
          />
        )}
      </div>
    </>
  );
}

export default TogetherSwiper;

const ColumnTitleText = styled(LSRgDisplay02)`
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;

  display: -webkit-box;
  -webkit-line-clamp: 2; // 원하는 라인수
  -webkit-box-orient: vertical;
`;

const SlideContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0px 80px;
  flex: 1;
  width: 100%;
  height: 222px;
  position: relative;
  background: ${({ backgroundImage }) =>
    backgroundImage
      ? `linear-gradient(#00000080, #00000080), url(${backgroundImage})`
      : "#00000080"};
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 15px;
  cursor: pointer;
  transition:
    filter 0.3s ease,
    transform 0.3s ease;

  &:hover {
    filter: brightness(1.2); /* 밝기 증가 효과 */
    transform: scale(1.02); /* 살짝 확대 효과 */
  }
`;
